module.exports = __webpack_public_path__ + "img/wmsgnl.749b945c.png";